import { Descriptions } from 'antd';
import * as React from 'react';
import { IOrderInfo } from 'src/entity/OrderEntity';
import I18N from 'src/services/I18NService';
import { MddDecimal } from '@macrocura/utils';

interface IMedicineSummaryProps {
  /** 订单明细 */
  orderInfo: IOrderInfo;

  currencySymbol: string;
}

class MedicineSummary extends React.Component<IMedicineSummaryProps> {
  render() {
    const { orderInfo, currencySymbol } = this.props;

    return (
      <div className="div-row">
        <div className="div-col-3 text-align-right" />
        <div className="div-col-15 order_info">
          <Descriptions title="" bordered={false}>
            <Descriptions.Item label={I18N.get('order_drugs_amount')}>
              {currencySymbol}
              {orderInfo.total_price.toFixed(2)} ({I18N.get('med_preserve_price')}: {currencySymbol}{(orderInfo.drug_total_floor_price || 0).toFixed(2)})
            </Descriptions.Item>
            {orderInfo.discount > 0 && <Descriptions.Item label={I18N.get('common_discount_rate')}>{orderInfo.discount}</Descriptions.Item>}
            {orderInfo.processing_price && (
              <Descriptions.Item label={I18N.get('order_processing_price')}>
                {currencySymbol}
                {orderInfo.processing_price.toFixed(2)}
              </Descriptions.Item>
            )}
            {orderInfo.package_price && (
              <Descriptions.Item label="包装费">
                {currencySymbol}
                {orderInfo.package_price.toFixed(2)}
              </Descriptions.Item>
            )}
            {orderInfo.is_created_by_external && orderInfo.is_use_medical_insurance && (
              <Descriptions.Item label="医保金额">
                -{currencySymbol}
                {orderInfo.medical_insurance_amount.toFixed(2)}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="运费">{(orderInfo.shipping_cost || 0) > 0 ? currencySymbol + orderInfo.shipping_cost : '免邮'}</Descriptions.Item>
            {!!orderInfo.promotion_discount_amount && (
              <Descriptions.Item label="已优惠">{'-' + currencySymbol + orderInfo.promotion_discount_amount}</Descriptions.Item>
            )}
            <Descriptions.Item label={I18N.get('order_payment_amount')}>
              <span style={{ color: '#1FB8CD' }}>
                {currencySymbol}
                {orderInfo.order_payment_amount}
              </span>
            </Descriptions.Item>
          </Descriptions>{' '}
        </div>
      </div>
    );
  }
}

export default MedicineSummary;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/MedicineSummary.tsx